import { Typography } from '@mui/material';
import ManageChoiceGroupTable from './ManageChoiceGroupTable';
const ManageChoiceGroup = () => {
  return (
    <>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Manage Choice Group
      </Typography>
      <ManageChoiceGroupTable />
    </>
  );
};

export default ManageChoiceGroup;
